<template>
  <div>
    <el-dialog name="optionEdit" width="250px" append-to-body :visible.sync="optionForm.dialog" title="选项编辑">
      <survey-option-form v-if="optionForm.dialog" :option="optionForm.form" @save="saveOption"></survey-option-form>
    </el-dialog>

    <el-dialog name="questionEdit" @close="questionFormDataClear" append-to-body :visible.sync="questionForm.dialog" title="问卷问题编辑" width="400px">
      <div class="space-between-y">
        <input-item label="问题类型">
          <el-select v-model="questionForm.questionType" filterable clearable>
            <el-option v-for="(item,index) in options.question" :key="index" :value="item.value" :label="item.label"/>
          </el-select>
        </input-item>
        <input-item label="问题内容">
          <el-input clearable v-model="questionForm.questionContent" type="text" placeholder="请输入问题内容"></el-input>
        </input-item>
        <div v-if="questionForm.questionType === 'SINGLE_CHOICE' || questionForm.questionType === 'MULTIPLE_CHOICE'">
          <el-button plain type="primary" @click="createQuetionOption">新增选项</el-button>
        </div>

        <input-item label="问题选项" v-if="questionForm.questionType === 'SINGLE_CHOICE' || questionForm.questionType === 'MULTIPLE_CHOICE'">
          <el-table :data="questionForm.options">
            <el-table-column type="index" prop="#"></el-table-column>
            <el-table-column label="选项" prop="value"></el-table-column>
            <el-table-column label="选项描述" prop="description"></el-table-column>
            <el-table-column label="选项附图" prop="url">
              <template slot-scope="scope">
                <cloud-img :url="scope.row.url" :img-height="30" :img-width="30" :border-radius="6"></cloud-img>
              </template>
            </el-table-column>
            <el-table-column label="操作" width="90">
              <template slot-scope="scope">
                <el-button size="mini" type="text" @click="editOption(scope.row)">编辑</el-button>
                <el-button size="mini" type="text" @click="deleteOption(scope.row)">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
        </input-item>
        <input-item label="是否必填">
          <el-switch v-model="questionForm.isRequired"></el-switch>
        </input-item>
        <input-item>
          <el-button type="primary" @click="saveQuestionItem">保存</el-button>
        </input-item>
      </div>
    </el-dialog>

    <div class="space-between-y">
      <input-item label="问卷标题">
        <el-input clearable v-model="vo.title" type="text" placeholder="请输入问卷标题"></el-input>
      </input-item>
      <input-item label="问卷描述">
        <el-input clearable v-model="vo.description" type="text" placeholder="请输入问卷描述"></el-input>
      </input-item>
      <input-item label="状态设置">
        <el-select v-model="vo.status" filterable clearable>
          <el-option v-for="item in options.status" :key="item.value" :label="item.label" :value="item.value">
          </el-option>
        </el-select>
      </input-item>
      <input-item label="发起该问卷的页面URL">
        <el-input clearable v-model="vo.url" type="text" placeholder="请输入发起该问卷的页面URL"></el-input>
      </input-item>

      <el-button type="primary" plain icon="el-icon-plus" @click="createQuestion" style="margin-bottom: 8px;width: 120px">
        新增问题
      </el-button>

      <el-table :data="vo.questions" border stripe>
        <el-table-column width="50" type="index" label="#"></el-table-column>
        <el-table-column prop="questionType" label="问题类型"></el-table-column>
        <el-table-column prop="questionContent" label="问题内容"></el-table-column>
        <el-table-column width="70" prop="isRequired" label="是否必填">
          <template slot-scope="scope">
            <el-switch v-model="scope.row.isRequired" active-color="#13ce66" inactive-color="#e8effa"></el-switch>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="90">
          <template slot-scope="scope">
            <el-button size="mini" type="text" @click="editQuestion(scope.row)">编辑</el-button>
            <el-button size="mini" type="text" @click="deleteQuestion(index)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div>
        <el-button style="width: 100%;" type="primary" @click="saveQuestionnaire">保存问卷</el-button>
      </div>
    </div>

  </div>
</template>

<script>
import {survey} from "@/api/miu/survey";
import InputItem from "@/components/base/layout/InputItem.vue";
import SurveyOptionForm from "@/components/SurveyOptionForm.vue";
import CloudImg from "@/components/base/layout/img/CloudImg.vue";
import {utils} from "@/util/utils";

const dto = {
  id: null,
  title: "",
  description: "",
  url: "",
  status: null,
  questions: [],
};
const questionForm = {
  id: null,
  type: null,
  content: "",
  isRequired: false,
  options: [],
  isMultiple: false
};

function getQuestion() {
  return [
    {
      label: '单选',
      value: 'SINGLE_CHOICE'
    },
    {
      label: '多选',
      value: 'MULTIPLE_CHOICE'
    },
    {
      label: '文本',
      value: 'TEXT'
    },
    {
      label: '数字',
      value: 'NUMBER'
    },
    {
      label: '日期',
      value: 'DATE'
    },
    {
      label: '时间',
      value: 'DATETIME'
    }
  ];
}

function getStatus() {
  return [
    {
      label: '发布',
      value: 'PUBLISHED'
    },
    {
      label: '已完成',
      value: 'COMPLETED'
    },
    {
      label: '已关闭',
      value: 'CLOSED'
    },
    {
      label: '草稿',
      value: 'DRAFT'
    },
  ];
}

export default {
  name: 'SurveyForm',
  components: {
    CloudImg,
    SurveyOptionForm,
    InputItem
  },

  props: {
    id: {
      type: Number,
    }
  },

  data() {
    return {
      vo: dto,

      optionForm: {
        isNew: false,
        dialog: false,
        form: {
          id: null,
          value: "",
          description: "",
          url: ""
        }
      },

      questionForm: {
        isNew: false,
        dialog: false,
        ...questionForm
      },

      inputVisible: false,
      inputValue: '',

      options: {
        question: getQuestion(),
        status: getStatus()
      }

    }
  },


  created() {
    this.getData();
  },

  methods: {
    saveOption(option) {
      console.log("save option:");
      console.log(option);
      this.optionForm.dialog = false;
      this.optionForm.form = null;

      if (this.optionForm.isNew) {
        this.questionForm.options.push(option);
      } else {
        let index = this.questionForm.options.findIndex(item => item.id === option.id);
        this.questionForm.options.splice(index, 1, option);
      }
    },

    createQuetionOption() {
      this.optionForm.dialog = true;
      this.optionForm.isNew = true;
      this.optionForm.form = {
        id: null,
        value: "",
        description: "",
        url: ""
      };
    },

    editOption(option) {
      this.optionForm.dialog = true;
      this.optionForm.isNew = false;
      this.optionForm.form = {
        id: option.id,
        value: option.value,
        description: option.description,
        url: option.url
      };
    },

    deleteOption(option) {
      this.questionForm.options.splice(this.questionForm.options.indexOf(option), 1);
    },

    editQuestion(question) {
      this.questionForm = {
        dialog: true,
        ...question
      };
    },

    getQuDto() {
      return {
        id: this.vo.id,
        questionnaireTitle: this.vo.title,
        questionnaireDesc: this.vo.description,
        url: this.vo.url,
        status: this.vo.status,
        questions: this.vo.questions,
      }
    },

    saveQuestionnaire() {

      if (this.vo.id) {
        survey.updateQuestionnaire(this.getQuDto()).then(res => {
          this.$emit("saved");
        });
      } else {
        survey.createQuestionnaire(this.getQuDto()).then(res => {
          this.$emit("saved");
        });
      }
    },

    deleteQuestion(index) {
      this.vo.questions.splice(index, 1);
    },

    getQuestionFormDto() {
      return {
        id: this.questionForm.id || utils.random.generateRandomId(),
        questionType: this.questionForm.questionType,
        questionContent: this.questionForm.questionContent,
        isRequired: this.questionForm.isRequired,
        options: this.questionForm.options,
      };
    },

    saveQuestionItem() {
      if (this.questionForm.isNew) {
        this.vo.questions.push(this.getQuestionFormDto());
      } else {
        let index = this.vo.questions.findIndex(item => item.id === this.questionForm.id);
        this.vo.questions.splice(index, 1, this.getQuestionFormDto());
      }

      this.questionForm.dialog = false;
      this.questionFormDataClear();
    },

    questionFormDataClear() {
      this.questionForm = {
        ...questionForm,
        dialog: false,
        isNew: false,
      };
      this.questionForm.options = [];
      this.optionForm.form = null;


      console.log("questionFormDataClear");

    },

    createQuestion() {
      console.log("create question");

      try {
        this.questionForm.isNew = true;
        this.questionForm.id = null;
        this.questionForm.dialog = true;
        this.optionForm.form = null;
      } catch (e) {
        console.error(e);
      }
    },

    getData() {
      this.vo = {
        ...dto,
        id: this.id
      };

      if (this.id) {
        survey.getQuestionnaireDetail(this.id).then(res => {
          let vo = res.data;

          vo.questions.forEach(question => {
            question.isRequired = question.isRequired === 1;
            question.options.forEach(option => {
              option.url = option.imgUrl;
            });
          });

          this.vo = vo;
        });
      }

    },
  },


};
</script>

<style scoped>

.question {
  background: #f3f3f3;
  padding: 12px;
  border-radius: 8px;
  display: flex;
  gap: 8px;
  flex-flow: column;
}

.question-item {
  align-items: center;
  display: flex;
  gap: 8px;
}

.options {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
}
</style>
